import { IconButton, makeStyles } from '@material-ui/core';
import ExportIcon from '@material-ui/icons/GetApp';
import { saveAs } from 'file-saver';
import { observer } from 'mobx-react';
import React from 'react';
import { mg } from '../mg/mg';
import { toasterSvc } from '../services/ToasterSvc';
import { useOmnistore } from '../stores/Omnistore';

const useStyles = makeStyles({
	ExportButton: {
	},
});

interface IDownloadButtonProps {
	path: string
	params: Record<string, string|number>
	className?: string
}

export const ExportButton = observer(function(props: IDownloadButtonProps) {
	const classes = useStyles();
	const {path, params, className} = props;
	const communicator = useOmnistore().communicator;
	async function onClick(e: React.MouseEvent) {
		e.stopPropagation();
		const response = await communicator.doDownload(path, params);
		toasterSvc.handleResponse('')(response);
		if (response.blob) saveAs(response.blob, path);
	}
	return <IconButton onClick={onClick} className={mg.clsn(classes.ExportButton, className)}><ExportIcon/></IconButton>;
});
